import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';

import { BarChart, LineChart } from 'echarts/charts';
import { DatasetComponent, GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { routes } from './app.routes';
import { ApiGraphsDataSource, GraphsDataSource } from './features/graphs/services/graphs.datasource';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApiProjectInfoDataSource,
  ProjectInfoDataSource,
} from './features/project-info/services/project-info.datasource';
import { ApiSolutionsDataSource, SolutionsDataSource } from './features/solutions/services/solutions.datasource';
import { ApiProductsDataSource, ProductsDataSource } from './features/products/services/products.datasource';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { errorInterceptor } from './core/interceptors/error.interceptor';

echarts.use([LineChart, BarChart, GridComponent, TooltipComponent, DatasetComponent, CanvasRenderer, LegendComponent]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideEchartsCore({ echarts }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([errorInterceptor])),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
    { provide: GraphsDataSource, useClass: ApiGraphsDataSource },
    { provide: ProjectInfoDataSource, useClass: ApiProjectInfoDataSource },
    { provide: SolutionsDataSource, useClass: ApiSolutionsDataSource },
    { provide: ProductsDataSource, useClass: ApiProductsDataSource },
  ],
};
